export default __webpack_public_path__ + "static/media/linkedin-icon.cbd7debd.png";